export default {
    // VForm17VodalysBridge component translations
    'Download app': 'Télécharger l\'application',
    'Download for Windows': 'Télécharger pour Windows',
    'Download Vodalys Bridge for Windows': 'Télécharger Vodalys Bridge pour Windows',
    'Connection URL': 'Lien de connection',
    'Connection Code': 'Code de connexion',
    'Connection Code...': 'Code de connexion...',
    'Connect vodalys bridge': 'Connecter vodalys bridge',
    'Copy': 'Copier',
    // VodalysBridgeInstruction component translations
    'With Vodalys Bridge, you can stream NDI® sources directly to vodalys.io.': 'Avec Vodalys Bridge, vous pouvez diffuser des sources NDI® directement vers vodalys.io.',
    'Simply download and install': 'Téléchargez et installez simplement',
    'the Vodalys Bridge app on your computer to get started.': 'l\'application Vodalys Bridge sur votre ordinateur pour commencer.',
    'Use': 'Utilisez',
    'the connection link': 'le lien de connexion',
    'or copy the code to connect Vodalys Bridge to vodalys.io.': 'ou copiez le code pour connecter Vodalys Bridge à vodalys.io.',
    'Vodalys Bridge connect': 'Connecter Vodalys Bridge',
    'Microsoft teams': 'Microsoft Teams',
    'Activate NDI® in Microsoft Teams': 'Activer NDI® dans Microsoft Teams',
    'NDI® network sources': 'Sources NDI® du réseau',
    'Open Microsoft Teams and start a meeting or join one.': 'Ouvrez Microsoft Teams et démarrez une réunion ou rejoignez-en une.',
    'Open the More actions menu (three dots), then select Live broadcast.': 'Ouvrez le menu Plus d’actions (trois points), puis sélectionnez Diffusion en continu.',
    'In Live broadcast, select Broadcast over NDI®.': 'Dans Diffusion en continu, sélectionnez Diffusion sur NDI®.',
    'Confirm the NDI® broadcast when prompted.': 'Confirmez la diffusion NDI® lorsque cela est demandé.',
    'In Vodalys Bridge, pick the NDI® source from Teams.': 'Dans Vodalys Bridge, sélectionnez la source NDI® depuis Teams.',
    'Vodalys Bridge lists NDI® sources available on your local network.': 'Vodalys Bridge liste les sources NDI® disponibles sur votre réseau local.',
    'Select a source and start broadcasting to vodalys.io.': 'Sélectionnez une source et démarrez la diffusion vers vodalys.io.',
    'Make sure your computer and NDI® devices are on the same local network.': 'Assurez-vous que votre ordinateur et vos appareils NDI® sont sur le même réseau local.',
    'Microsoft Teams NDI® broadcast menu': 'Menu de diffusion NDI® de Microsoft Teams'
}

